export const ENABLE_TOOLBAR = 'ENABLE_TOOLBAR'
export const DISABLE_TOOLBAR = 'DISABLE_TOOLBAR'

export const START = 'START'
export const ACCEPT_TERMS = 'ACCEPT_TERMS'
export const LOADING = 'LOADING'

export const SET_USER = 'SET_USER'
export const SET_HORSE = 'SET_HORSE'
export const SET_VET = 'SET_VET'
export const SET_FARRIER = 'SET_FARRIER'

export const SET_RATION_ID = 'SET_RATION_ID'
export const SET_RATION = 'SET_RATION'
export const SET_STDRATION_INFO = 'SET_STDRATION_INFO'

export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_REMEMBER_FLAG = 'SET_REMEMBER_FLAG'
export const SET_HELP = 'SET_HELP'

export const SET_BREEDTYPE_IDX = 'SET_BREEDTYPE_IDX'
export const SET_BREED = 'SET_BREED'
export const SET_BREED_IDX = 'SET_BREED_IDX'
export const SET_BREEDS = 'SET_BREEDS'

export const SET_HORSE_WEIGHT = 'SET_HORSE_WEIGHT'
export const SET_WEIGHT_ID = 'SET_WEIGHT_ID'
export const SET_WEIGHTS = 'SET_WEIGHTS'

export const SET_PHASETYPE_IDX = 'SET_PHASETYPE_IDX'
export const SET_PHASE = 'SET_PHASE'
export const SET_PHASE_IDX = 'SET_PHASE_IDX'
export const SET_PHASES = 'SET_PHASES'

export const SET_ACTIVITYTYPE_IDX = 'SET_ACTIVITYTYPE_IDX'
export const SET_ACTIVITY = 'SET_ACTIVITY'
export const SET_ACTIVITY_IDX = 'SET_ACTIVITY_IDX'
export const SET_ACTIVITIES = 'SET_ACTIVITIES'

export const SET_NUTRIENTS = 'SET_NUTRIENTS'
export const SET_AVAILABLE_NUTRIENTS = 'SET_AVAILABLE_NUTRIENTS'
export const SET_SELECTED_NUTRIENTS = 'SET_SELECTED_NUTRIENTS'

export const ERROR = 'ERROR'
export const CLEAR_ERROR = 'CLEAR_ERROR'



// WEBPACK FOOTER //
// ./src/constants/store.js